import { withI18n } from 'react-i18next';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import {
  categoriesActions,
  activeSubcategoryNameSel,
  activeSubcategoryIDSel,
  subcategoriesSel
} from 'src/store/modules/categories';

import { activeAccountSel } from 'src/store/modules/signin';

import CategoriesFilter from './CategoriesFilter';

interface IDispatchFromProps {
  getSubcategories: any;
  getProductsByCategory: any;
}

const mapStateToProps = (state: any) => {
  return {
    isLoggedIn: state.signin.success,
    subcategories: subcategoriesSel(state),
    activeSubcategoryID: activeSubcategoryIDSel(state),
    activeAccount: activeAccountSel(state),
    activeSubcategoryName: activeSubcategoryNameSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  getSubcategories: (categoryId: string) =>
    dispatch(categoriesActions.getSubcategories(categoryId)),
  getProductsByCategory: (
    subcategoryId: number,
    activeAccount: string,
    pageNumber: number,
    categoryName: string
  ) =>
    dispatch(
      categoriesActions.getProductsByCategory(
        subcategoryId.toString(),
        categoryName,
        activeAccount,
        pageNumber
      )
    )
});

export const pureComponent = CategoriesFilter;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(withRouter(CategoriesFilter)));
